//      
import React, { Component } from 'react';

import { mergeClassNames } from 'utils/functions';

              
                 
                  
                     
                            
                         
                       
                       
  

export class SwitchInput extends Component        {
    static defaultProps = {
        name: '',
        label: '',
    };

    render() {
        let { name, label, ...props } = this.props;
        let {
            checked,
            defaultChecked,
            disabled,
            onChange,
            className,
            ...domProps
        } = props;
        className = mergeClassNames('custom-control custom-switch', className);

        return (
            <div {...domProps} className={className}>
                <input
                    type='checkbox'
                    className='custom-control-input'
                    id={`id_${name}`}
                    checked={checked}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    onChange={onChange}
                />
                <label className='custom-control-label' htmlFor={`id_${name}`}>
                    {label}
                </label>
            </div>
        );
    }
}

export default SwitchInput;
